import {Pipe, PipeTransform} from "@angular/core";
import {CallType} from "../../model/callType";

@Pipe({name: 'callType'})
export class CallTypePipe implements PipeTransform {
    transform(value: any) {
        return CallType[value];
    }
}
